
import { Button } from "../../../../components/button";

import { Divider } from "../../../../components/divider";

import optimizations from "../../../../data/optimizations.json" with { type: 'json' };

import { 
  
  Optimization,

  OptimizationContent,
  
  OptimizationHeader,

  OptimizationNumber,
  
  OptimizationSubheader

} from "../../../../components/optimization";

export default function Optimization() {

  return (

    <div className="flex flex-col items-center pt-4">
      
      <h3 className="font-bold text-xl text-blue-primary pb-6">
        
        But every lab has a clear path to optimization. Here are your next steps:
        
      </h3>

      <div className="flex flex-col gap-10">

      { optimizations.map( optimization => (

        <div key={ optimization.id } className="flex flex-col gap-5 sm:gap-10">

          <Divider />

          <Optimization>

            <OptimizationNumber>{ optimization.id }</OptimizationNumber>

            <OptimizationContent className="max-w-9/10">

              <OptimizationHeader>{ optimization.header }</OptimizationHeader>

              <OptimizationSubheader>{ optimization.subheader }</OptimizationSubheader>

            </OptimizationContent>

            <Button asChild className="mt-4" size="small" variant="secondary">

              <a href={ optimization.href } target="_blank">

                { optimization.button }

              </a>

            </Button>
            
          </Optimization>

        </div>
        
      ) ) }

      </div>

    </div>

  )

}
